
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import ModalContent from '@/components/modal/ModalContentNew.vue';
import ModalFullScreen from '@/components/modal/ModalFullScreenNew.vue';
import VisitsTable from '@/components/projects/VisitsTable.vue';
import UIButton from "@/components/button/ui-button.vue";
import { Project, Project_Activity, User } from '@/generated/graphql';
import { NOTIFICATION } from "@/entities/Events";
import Message, { MessageDuration } from "@/data/notificationsMessages";
import ClientVisitsConfirmModal from "@/components/companyProjects/ClientVisitsConfirmModal.vue";

enum MODE {
    ACCEPT = "ACCEPT",
    REJECT = "REJECT",
}

@Component({
    components: {
        ModalFullScreen,
        ModalContent,
        VisitsTable,
        UIButton,
        ClientVisitsConfirmModal
    }
})

export default class ClientVisitsModal extends Vue {
    @Prop({ type: Object, required: true }) readonly client!: Project;
    @Prop({ type: Object, required: true }) readonly currentUser!: User;
    @Prop({ type: String, required: true }) readonly currentMode: MODE;
    areAllItemsSelected = false;
    toggleVisitsConfirmModal = false;
    selectedVisits: Project_Activity[] = [];
    headers = [
        { text: 'Client', value: 'client' },
        { text: 'Location', value: 'location' },
        { text: 'Date & Time', value: 'date_time' },
        { text: 'Activity', value: 'activity' },
    ];

    get modalTitle() {
        const totalVisits = this.client.project_activities.length
        if (this.currentMode === MODE.ACCEPT) {
            return `Visits to accept (${totalVisits})`
        } else if (this.currentMode === MODE.REJECT) {
            return `Visits to decline (${totalVisits})`
        }
    }

    get buttonText() {
        if (this.currentMode === MODE.ACCEPT) {
            return "Accept"
        } else if (this.currentMode === MODE.REJECT) {
            return "Decline"
        }
    }

    handleSelectAll(event) {
        if (this.areAllItemsSelected) {
            this.selectedVisits = [];

            this.areAllItemsSelected = false;
        } else {
            this.selectedVisits = [...this.client.project_activities];

            this.areAllItemsSelected = true;
        }
    }

    handleRowCheckboxChange(manager) {
        const index = this.selectedVisits.findIndex(
            (item) => item.id === manager.id
        );

        if (index >= 0) {
            this.selectedVisits.splice(index, 1);
        } else {
            this.selectedVisits.push(manager);
        }
    }

    // updateVisitsConfirmAcceptModal(status: boolean) {
    //     if (status) {
    //         this.currentMode = MODE.ACCEPT
    //     }
    //     this.toggleVisitsAcceptModal = status;
    // }

    async submit() {
        // Log the parameters that would be sent to declined visit matches lambda
        console.debug('🎯 ClientVisitsModal submit - Current mode:', this.currentMode);
        console.debug('🎯 ClientVisitsModal submit - Current user ID:', this.currentUser.id);
        console.debug('🎯 ClientVisitsModal submit - Selected visits:', this.selectedVisits.map(visit => ({
            id: visit.id,
            title: visit.title,
            client_name: visit.project?.client_name
        })));

        // If declining visits, trigger the declined visit matches lambda for each visit
        if (this.currentMode === MODE.REJECT) {
            console.debug('🚨 Declining visits - will trigger declined visit matches lambda');
            
            for (const visit of this.selectedVisits) {
                console.debug(`📤 Would send to lambda - project_activity_id: ${visit.id}, user_id: ${this.currentUser.id}`);
                
                // TODO: Add actual POST request to lambda here
                // await this.recordDeclinedVisitMatch(visit.id, this.currentUser.id);
            }
        }

        this.$emit('onSubmit', this.selectedVisits);
    }

    closeModal() {
        this.$emit('close');
    }
}
